import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../../../interfaces';
import { showModal, hideModal } from '../../../../redux/slices/modal';
import { resetApiThunk } from '../../../../redux/thunks/api';
import { thunks } from '../../../../redux/thunks/thunks';
import PaymentFailedShopper from './PaymentFailedShopper';

const mapState = (state: AppState) => ({
  modal: state.modal,
  resetApi: resetApiThunk
});

const mapDispatch = {
  showModal,
  hideModal,
  getWalletPinStatus: thunks.GET_WALLETPIN_STATUS,
  getHistory : thunks.GET_PERSONAL_SHOPPING_LIST,
};

const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(PaymentFailedShopper);
